import { render, staticRenderFns } from "./update-marque.vue?vue&type=template&id=1efbbe08"
import script from "./update-marque.vue?vue&type=script&lang=js"
export * from "./update-marque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports